import { UnidadesFilterDTO } from '@/interfaces/clientUnit';
import { apiClient } from '@/services/api';
import { ENDPOINTS } from '@/settings/api-settings';
import { AxiosResponse } from 'axios';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function getClientUnitsDataReport(filter: UnidadesFilterDTO): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.CLIENT_UNITS_REPORT, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function buildClientUnitsXlsReport(filters: UnidadesFilterDTO): Observable<AxiosResponse> {
  return from(
    apiClient.download(ENDPOINTS.CLIENT_UNITS_REPORT_XLS, filters),
  );
}